type PostTitleOptionsType = {
    lifeUpdate: 'LIFE UPDATE',
    question: 'QUESTION', 
    pondering: 'PONDERING',
    spiritualLesson: 'LESSON',
    insight: 'INSIGHT', 
    needHelp: 'NEED HELP',
    eventNotice: 'EVENT NOTICE',
    invite: 'INVITE',
    other: 'OTHER',
}
export const PostTitleOptions: PostTitleOptionsType = {
    lifeUpdate: 'LIFE UPDATE',
    question: 'QUESTION', 
    pondering: 'PONDERING',
    spiritualLesson: 'LESSON',
    insight: 'INSIGHT', 
    needHelp: 'NEED HELP',
    eventNotice: 'EVENT NOTICE',
    invite: 'INVITE',
    other: 'OTHER',
}

export type PostTitleOptionsValues = typeof PostTitleOptions[keyof typeof PostTitleOptions]

export const AllPostTitleOptions: PostTitleOptionsValues[] = Array.from(Object.values(PostTitleOptions));

export const PostTitleOptionsQuestions:{ [key in PostTitleOptionsValues]: string } = {
    [PostTitleOptions.lifeUpdate]: 'What is going on in your life?',
    [PostTitleOptions.question]: 'What would you like to ask your group?',
    [PostTitleOptions.pondering]: 'What are you pondering?',
    [PostTitleOptions.insight]: 'What spiritual insight would you like to share?',
    [PostTitleOptions.spiritualLesson]: 'What spiritual lesson would you like to share?',
    [PostTitleOptions.needHelp]: 'What do you need help with?',
    [PostTitleOptions.eventNotice]: 'What event is going on?',
    [PostTitleOptions.invite]: 'What are you inviting people to do?',
    [PostTitleOptions.other]: 'What is your custom message?',
}

export default PostTitleOptions;